import {
    FETCH_PHARMACIES_FULFILLED,
    FETCH_PHARMACIES_PENDING,
    FETCH_PHARMACIES_REJECTED,
    FETCH_PHARMACY_PENDING,
    FETCH_PHARMACY_FULFILLED,
    FETCH_PHARMACY_REJECTED,
    SEARCH_PHARMACIES_FULFILLED,
    SORT_PHARMACIES_FULFILLED,
    UPDATE_PHARMACY_PENDING,
    UPDATE_PHARMACY_FULFILLED,
    UPDATE_PHARMACY_REJECTED,
    UPDATE_PHARMACY_ALIASES_PENDING,
    UPDATE_PHARMACY_ALIASES_FULFILLED,
    UPDATE_PHARMACY_ALIASES_REJECTED,
    SORT_PHARMACIES_PENDING,
    FILTER_PHARMACIES_FULFILLED,
    FILTER_PHARMACIES_PENDING,
    ADD_PHARMACY_FULFILLED,
    ADD_PHARMACY_REJECTED, 
    ADD_PHARMACY_PENDING,
} from '../Actions/PharmacyActions';

import { FilterType } from '../../DeviceBrowser/FilterType';
import { SortType } from '../../DeviceBrowser/SortType';
import { DirectionType } from '../../DeviceBrowser/DirectionType';
import moment from 'moment';

// Initialise State
const initialState = {
    pharmacy: {},
    pharmacies: [],
    filteredPharmacies: [],
    activeFilter: FilterType.ALL,
    activeSort: SortType.ALPHABETICALLY,
    activeDirection: DirectionType.ASCENDING,
    fetching: false,
    fetched: false,
    failed: false,
    updatingPharmacy: false,
    updatedPharmacy: false,
    updatingPharmacyAliases: false,
};

// Reducer
export const PharmaciesReducer = (state = initialState, action) => {
    
    let newState = Object.assign({}, state);

    function getLatestEvent(pharmacy) {
        if(pharmacy.hasOwnProperty("devices")) {
            let deviceKeys = Object.keys(pharmacy.devices);
            let times = []
            deviceKeys.forEach(deviceKey => {
                let device = pharmacy.devices[deviceKey];
                let event = getDeviceEvent(device);
                if (event !== undefined) {
                    times.push(event);
                }
            })
            
            let minTime = times.sort((time1, time2) => {
                if(time1[2] <= time2[2]) {
                    return -1;
                }
                else if (time1[2] == time2[2]) {
                    return 0;
                }

                return 1;
            })

            if (minTime[0] !== undefined) {
                minTime = minTime[0];
                let minutes = minTime[2];
    
                return minutes;
            }
        }
        return Math.pow(10, 1000);
    }

    function getLatestTouchedEvent(pharmacy) {
        if(pharmacy.hasOwnProperty("devices")) {
            let deviceKeys = Object.keys(pharmacy.devices);
            let times = [];
            deviceKeys.forEach(deviceKey => {
                let device = pharmacy.devices[deviceKey];
                let event = getLastTouchedEvent(device);
                if (event !== undefined) {
                    times.push(event);
                }
            })
            
            let minTime = times.sort((time1, time2) => {
                if(time1[2] <= time2[2]) {
                    return -1;
                }
                else if (time1[2] == time2[2]) {
                    return 0;
                }

                return 1;
            })

            if (minTime[0] !== undefined) {
                minTime = minTime[0];
                let minutes = minTime[2];
    
                return minutes;
            }
        }
        return Math.pow(10, 1000);
    }
    
    function getLatestReportEvent(pharmacy) {
        if(pharmacy.hasOwnProperty('devices')) {
            let deviceKeys = Object.keys(pharmacy.devices);
            let times = [];
            deviceKeys.forEach(deviceKey => {
                let device = pharmacy.devices[deviceKey];
                let event = getLastReportEvent(device);
                if (event !== undefined) {
                    times.push(event);
                }
            })
            
            let minTime = times.sort((time1, time2) => {
                if(time1[2] <= time2[2]) {
                    return -1;
                }
                else if (time1[2] == time2[2]) {
                    return 0;
                }

                return 1;
            })

            if (minTime[0] !== undefined) {
                minTime = minTime[0];
                let minutes = minTime[2];
    
                return minutes;
            }
        }
        return Math.pow(10, 1000);
    }
    
    function sort(pharmacies, sortType, directionType) {
        return pharmacies.sort(function(a, b) {
            if (sortType === SortType.ALPHABETICALLY) {
                var nameA = a.campaignName.toLowerCase(), nameB = b.campaignName.toLowerCase();
                if (nameA < nameB) //sort string ascending
                    return directionType === DirectionType.ASCENDING ? -1 : 1;
                if (nameA > nameB)
                    return directionType === DirectionType.ASCENDING ? 1 : -1;
                return 0;
            } else if (sortType === SortType.MDM_ID) {
                var mdm1 = a.mdmId, mdm2 = b.mdmId;

                if (mdm1 < mdm2) //sort string ascending
                    return directionType === DirectionType.ASCENDING ? -1 : 1;
                if (mdm1 > mdm2)
                    return directionType === DirectionType.ASCENDING ? 1 : -1;
                return 0;
            } else if (sortType === SortType.LAST_ACTIVE) {
                let latestEvent1 = getLatestEvent(a);
                let latestEvent2 = getLatestEvent(b);

                if (latestEvent1 < latestEvent2) {
                    return directionType === DirectionType.ASCENDING ? -1 : 1;
                } else if (latestEvent1 > latestEvent2) {
                    return directionType === DirectionType.ASCENDING ? 1 : -1;
                } 
                
                return 0;
            } else if (sortType === SortType.LAST_REPORT) {
                let latestEvent1 = getLatestReportEvent(a);
                let latestEvent2 = getLatestReportEvent(b);

                if (latestEvent1 < latestEvent2) {
                    return directionType === DirectionType.ASCENDING ? -1 : 1;
                } else if (latestEvent1 > latestEvent2) {
                    return directionType === DirectionType.ASCENDING ? 1 : -1;
                } 
                
                return 0;
            } else if (sortType === SortType.LAST_TOUCHED) {
                let latestEvent1 = getLatestTouchedEvent(a);
                let latestEvent2 = getLatestTouchedEvent(b);

                if (latestEvent1 < latestEvent2) {
                    return directionType === DirectionType.ASCENDING ? -1 : 1;
                } else if (latestEvent1 > latestEvent2) {
                    return directionType === DirectionType.ASCENDING ? 1 : -1;
                } 
                
                return 0;
            }
        });
    }


    function filter(pharmacies, filterType) {
        return pharmacies.filter(pharmacy => {
            if (filterType === FilterType.ALL) {
                return !pharmacy.isTest && !pharmacy.isDeactivated;
            } else if (filterType === FilterType.ASSOCIATED) {
                return pharmacy.deviceUuids !== undefined;
            } else if (filterType === FilterType.UNASSOCIATED) {
                return pharmacy.deviceUuids === undefined;
            } else if (filterType === FilterType.TESTING) {
                return pharmacy.isTest;
            } else if (filterType === FilterType.DEACTIVATED) {
                return pharmacy.isDeactivated;
            } else if (filterType === FilterType.REQUIRES_ATTENTION) {
                return pharmacy.properties.batteryLow;
            }
            return false;
        });
    }


    function search(pharmacies, searchText) {
        return pharmacies.filter(pharmacy => {
            return (pharmacy.id.toLowerCase()).includes(searchText);
        })
    }


    function getDeviceEvent(device) {
        if (device.hasOwnProperty("DeviceDetails")) {
            let timeStamp = device.DeviceDetails.DetailsTimestamp;
            if(timeStamp != undefined && timeStamp != null) {
                var now = moment(new Date()); //todays date
                var end = moment(timeStamp, "HH:mm:ss ddd DD-MM-YYYY"); // another date
                var duration = moment.duration(now.diff(end));
    
                var minutes = duration.asMinutes();
                var hours = duration.asHours();
                var days = duration.asDays();

                return [days, hours, minutes];
            }
        }
    }

    function getLastReportEvent(device) {
        if (device.hasOwnProperty("DeviceDetails")) {
            let reportDetails = device.DeviceDetails.latest;
            let lastDate = reportDetails.Latest_ReportUploaded;

            if(reportDetails != null && lastDate != null) {
                var now = moment(new Date()); //todays date
                var end = moment(lastDate, "HH:mm:ss ddd DD-MM-YYYY"); // another date
                var duration = moment.duration(now.diff(end));
    
                var minutes = duration.asMinutes();
                var hours = duration.asHours();
                var days = duration.asDays();

                return [days, hours, minutes];
            }
        }
    }
        
    function getLastTouchedEvent(device) {
        if (device.hasOwnProperty("DeviceDetails")) {
            if (device.hasOwnProperty("eventSummary")) {
                let reportStared = getEvent("ReportStarted", device.eventSummary);
                if (reportStared != null) {
                    var now = moment(new Date()); //todays date
                    var end = moment(reportStared.latest, "HH:mm:ss ddd DD-MM-YYYY"); // another date
                    var duration = moment.duration(now.diff(end));
        
                    var minutes = duration.asMinutes();
                    var hours = duration.asHours();
                    var days = duration.asDays();
        
                    return [days, hours, minutes];
                }
            }
        }   
    }

    function getEvent(event, array) {
        var foundItem;
        array.forEach(function (item, index) {
            if(item.name === event) {
                foundItem = item;
            }
        });

        return foundItem;
    }

    switch(action.type) {
        case ADD_PHARMACY_PENDING:
            return {
                ...state,
                fetching: true,
                fetched: false,
                failed: false
            };
        case ADD_PHARMACY_FULFILLED:
            let newPharmacy = action.payload;

            newState.pharmacies.push(newPharmacy);

            return {
                ...state,
                pharmacies: newState.pharmacies,
                fetching: false,
                fetched: true,
                failed: false,
            };
        case ADD_PHARMACY_REJECTED: 
            return {
                ...state,
                fetching: false,
                fetched: false,
                failed: true
            };
        case FETCH_PHARMACIES_PENDING:
            return {
                ...state,
                pharmacies: [],
                filteredPharmacies: [],
                fetching: true,
                fetched: false,
                failed: false
            };
        case FETCH_PHARMACIES_FULFILLED:
            let activeFilter = state.activeFilter;
            let activeSort = state.activeSort;
            let activeDirection = state.activeDirection;

            if (activeFilter === undefined) {
                activeFilter = FilterType.ALL;
            }

            if (activeSort === undefined) {
                activeSort = SortType.ALPHABETICALLY;
            }

            if (activeDirection === undefined) { 
                activeDirection = DirectionType.ASCENDING;
            }
            
            return {
                ...state,
                pharmacies: action.payload,
                filteredPharmacies: sort(filter(action.payload, activeFilter), activeSort, activeDirection),
                activeFilter: activeFilter,
                activeSort: activeSort,
                activeDirection: activeDirection,
                fetching: false,
                fetched: true,
                failed: false
            };
        case FETCH_PHARMACIES_REJECTED:
            return {
                ...state,
                pharmacies: [],
                filteredPharmacies: [],
                fetching: false,
                fetched: false,
                failed: true
            };
        case FETCH_PHARMACY_PENDING:
            return {
                ...state,
                pharmacy: [],
                fetching: true,
                fetched: false,
                failed: false
            };
        case FETCH_PHARMACY_FULFILLED:
            return {
                ...state,
                pharmacy: action.payload,
                fetching: false,
                fetched: true,
                failed: false
            };
        case FETCH_PHARMACY_REJECTED:
            return {
                ...state,
                pharmacy: [],
                fetching: false,
                fetched: false,
                failed: true
            };
        case SORT_PHARMACIES_PENDING:
            return {
                ...state,
                fetching: true,
                fetched: false,
                failed: false
            };
        case SORT_PHARMACIES_FULFILLED:            
            return {
                ...state,
                filteredPharmacies: sort(newState.filteredPharmacies, action.payload.sortType, action.payload.directionType),
                activeDirection: action.payload.directionType,
                activeFilter: state.activeFilter,
                activeSort: action.payload.sortType,
                fetching: false,
                fetched: true,
                failed: false
            };
        case FILTER_PHARMACIES_PENDING:
            return {
                ...state,
                fetching: true,
                fetched: false,
                failed: false
            };
        case FILTER_PHARMACIES_FULFILLED:
            return {
                ...state,
                filteredPharmacies: filter(newState.pharmacies, action.payload.filterType),
                activeFilter: action.payload.filterType,
                fetching: false,
                fetched: true,
                failed: false
            };
        case SEARCH_PHARMACIES_FULFILLED:
            return {
                ...state,
                filteredPharmacies: search(newState.pharmacies, action.payload.toLowerCase()),
                fetching: false,
                fetched: true,
                failed: false
            };
        case UPDATE_PHARMACY_PENDING:
            return {
                ...state,
                updatingPharmacy: true,
                updatedPharmacy: false,
            };
        case UPDATE_PHARMACY_FULFILLED:
            Object.keys(action.payload).map(deviceAttribute => {
                let attributeValue = action.payload[deviceAttribute];
                newState.pharmacy[deviceAttribute] = attributeValue;
            });
            
            return {
                ...state,
                updatingPharmacy: false,
                updatedPharmacy: true,
                pharmacy: newState.pharmacy,
            };
        case UPDATE_PHARMACY_REJECTED:
            return {
                ...state,
                updatingPharmacy: false,
                updatedPharmacy: false,
            };
        case UPDATE_PHARMACY_ALIASES_PENDING:
            return {
                ...state,
                updatingPharmacyAliases: true,
            };
        case UPDATE_PHARMACY_ALIASES_FULFILLED:
            Object.keys(action.payload).map(deviceAttribute => {
                let attributeValue = action.payload[deviceAttribute];
                newState.pharmacy[deviceAttribute] = attributeValue
            });
            
            return {
                ...state,
                updatingPharmacyAliases: false,
                pharmacy: newState.pharmacy,
            };
        case UPDATE_PHARMACY_ALIASES_REJECTED:
            return {
                ...state,
                updatingPharmacyAliases: false,
            };
        default:
            return state;
    }
};